export default __webpack_public_path__ + "static/media/FIN_2x.d399f9ef.png";